var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTraction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 22H21.5",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09998 8.38086H4.5C3.95 8.38086 3.5 8.83086 3.5 9.38086V18.0009C3.5 18.5509 3.95 19.0009 4.5 19.0009H6.09998C6.64998 19.0009 7.09998 18.5509 7.09998 18.0009V9.38086C7.09998 8.83086 6.64998 8.38086 6.09998 8.38086Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3002 5.18945H11.7002C11.1502 5.18945 10.7002 5.63945 10.7002 6.18945V17.9995C10.7002 18.5495 11.1502 18.9995 11.7002 18.9995H13.3002C13.8502 18.9995 14.3002 18.5495 14.3002 17.9995V6.18945C14.3002 5.63945 13.8502 5.18945 13.3002 5.18945Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5004 2H18.9004C18.3504 2 17.9004 2.45 17.9004 3V18C17.9004 18.55 18.3504 19 18.9004 19H20.5004C21.0504 19 21.5004 18.55 21.5004 18V3C21.5004 2.45 21.0504 2 20.5004 2Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraction);
export default __webpack_public_path__ + "static/media/traction.dae81790e32d231849549bdfe66abf98.svg";
export { ForwardRef as ReactComponent };